import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import Header from 'apps/components/header/header';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { ProfileCard } from 'legacyComponents/cards/types/profile';

import { staticURL } from 'core/url';
import { ConnectOrganisationsManager } from 'apps/home/connect/organisations/appManager';
import { ContentIntro } from 'apps/components/contentIntro';
import { conf } from 'apps/home/connect/config.yaml';

@withNamespaces()
@inject('routerStore')
@observer
export class ConnectOrganisations extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new ConnectOrganisationsManager(null, this.props);
  }

  render() {
    const { t } = this.props;
    const connection = this.appManager.initiativesConn;
    const organisations = connection.arrayApp;
    return (
      <>
        <Header />
        <ContentIntro
          title={conf.organisations.title}
          description={conf.organisations.description}
          createButtonText='Start an Organisation'
          createButtonLink='home.signUpOrganisation'
          hideButtonWhenSignIn={true}
          variant='primary'
          isCentered
          textCenter
          addSpacer
          hideIfSignedIn
          marginBottom='8rem'
          backgroundLayer={
            <>
              <img
                src={staticURL('assets/contentInfoBackgrounds/greyCircle.svg')}
                alt='background-image'
              />
              <img
                src={staticURL(
                  'assets/contentInfoBackgrounds/yellowTriangleBottomCircleTop.svg',
                )}
                alt='background-image'
              />
            </>
          }
        />
        <MainWrapper marginTop='2em'>
          <CardSection
            invisible={this.appManager.loading}
            title={t('All Organisations')}
            subTitle=' '
            isOwnProfile={false}
            ownerName=''
            cardApp={organisations}
            CardComponent={ProfileCard}
            noDataCardType='profile'
            gridColumns={3}
            last
          />
        </MainWrapper>
      </>
    );
  }
}

ConnectOrganisations.propTypes = {
  t: PropTypes.func,
};
